function insertDataInModalAndOpenModal(markup) {
    const $actionModal = $('#js-action-modal');

    const $actionModalContent = $actionModal.find('.modal-content');

    $actionModalContent.empty();

    $actionModalContent.append(markup);

    $actionModal.modal('show');
}

function getProductModal(productId) {
    $.ajax({
        url: '/ajax/productModal',
        type: 'post',
        data: {
            "data": productId
        }
    }).done(function (resp) {
        insertDataInModalAndOpenModal(resp);
    })
}

function getProductGroupsModal() {
    $.ajax({
        url: '/ajax/productGroupsModal',
        type: 'post'
    }).done(function (resp) {
        insertDataInModalAndOpenModal(resp);
    })
}


function getTranslationModal() {
    $.ajax({
        url: '/ajax/translationModal', 
        type: 'post'
    }).done(function (resp) {
        insertDataInModalAndOpenModal(resp);
    })
}

function getAddLanguageModal() {
    $.ajax({
        url: '/ajax/addLanguageModal',
        type: 'post'
    }).done(function (resp) {
        insertDataInModalAndOpenModal(resp);
    })
}

function getDeleteModal(confirmUrl, bodyText) {
    $.ajax({
        url: '/ajax/deleteModal',
        type: 'post',
        data: {
            "confirmUrl": confirmUrl,
            "bodyText": bodyText
        }
    }).done(function (resp) {
		insertDataInModalAndOpenModal(resp);
    })
}

function getProductCategoriesModal() {
    $.ajax({
        url: '/ajax/productCategoriesModal',
        type: 'post'
    }).done(function (resp) {
        insertDataInModalAndOpenModal(resp);
    })
}

function getProductInstancesModal() {
    $.ajax({
        url: '/ajax/productInstancesModal',
        type: 'post'
    }).done(function (resp) {
        insertDataInModalAndOpenModal(resp);
    })
}

function getAddAttributeKeysModal() {
    $.ajax({
        url: '/ajax/attributeKeysModal',
        type: 'post'
    }).done(function (resp) {
        insertDataInModalAndOpenModal(resp);
    })
}

export function initModal() {

    let productOpenButton = $('.js-open-product-modal');

    if (productOpenButton.length > 0) {
        productOpenButton.click(function () {
            let productId = $(this).parents('tr').attr('data-product');

            getProductModal(productId);
        });
    }

    let translationOpenButton = $('.js-open-translations-modal');

    if (translationOpenButton.length > 0) {
        translationOpenButton.click(function () {
            getTranslationModal();
        });
    }

    let productGroupOpenButton = $('.js-open-product-group-modal');

    if (productGroupOpenButton.length > 0) {
        productGroupOpenButton.click(function () {

            getProductGroupsModal();
        });
    }

    let productCategoriesOpenButton = $('.js-open-product-categories-modal');

    if (productCategoriesOpenButton.length > 0) {
        productCategoriesOpenButton.click(function () {

            getProductCategoriesModal();
        });
    }

    let productInstancesOpenButton = $('.js-open-product-instance-modal');

    if (productInstancesOpenButton.length > 0) {
        productInstancesOpenButton.click(function () {

            getProductInstancesModal();
        });
    }

    let deleteModalOpenButton = $('.js-open-delete-modal');

    if (deleteModalOpenButton.length) {
        $('body').on('click', '.js-open-delete-modal', function () {
			let bodyText = $(this).data('modal-text');
			let confirmUrl = $(this).data('confirmation-link');

			getDeleteModal(confirmUrl, bodyText);
		});
    }

    let addLanguageModalButton = $('.js-open-add-language-modal');

    if (addLanguageModalButton.length > 0) {
        addLanguageModalButton.click(function () {

            getAddLanguageModal();
        });
    }

    let addAttributeKeysButton = $('.js-open-attribute-keys-modal');

    if (addAttributeKeysButton.length > 0) {
        addAttributeKeysButton.click(function () {

            getAddAttributeKeysModal();
        });
    }
}

/**
 * @todo cleanup
 */
export function selectModal() {
    let instanceSelect = $('.js-instance-detail-select');

    $(document).on('change', instanceSelect, function () {
        let instanceButton = $('.js-instance-detail-button');

        let instanceId = $('.js-instance-detail-select').val();
        let dataUrl = instanceButton.data('url');

        if (instanceId != 0) {
            instanceButton.attr('disabled', false);
            instanceButton.removeClass('disabled');
            instanceButton.addClass('active');
            dataUrl = dataUrl + instanceId;
            instanceButton.attr('href', dataUrl);
        } else {
            instanceButton.attr("disabled", true);
            instanceButton.attr('href', '#');
            instanceButton.addClass('disabled');
            instanceButton.removeClass('active');
        }
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/contentElements/openModal.js